var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isMobile
        ? _c(
            "v-dialog",
            {
              attrs: {
                scrollable: "",
                "full-width": "",
                fullscreen: "",
                "hide-overlay": "",
                transition: "dialog-bottom-transition"
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "primary", dark: "", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-toolbar-title", { staticClass: "ma-0" }, [
                    _vm._v("View Submission")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("action-icons", {
                    attrs: {
                      marginZero: true,
                      fromDashboard: _vm.fromDashboard,
                      submission: _vm.submission
                    },
                    on: { "service-log:deleted": _vm.slDeleted }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    { staticStyle: { "padding-top": "70px" } },
                    [
                      _c("confirmation-page", {
                        attrs: {
                          fromDashboard: _vm.fromDashboard,
                          submission: _vm.submission,
                          dialog: _vm.dialog
                        },
                        on: { "close:dialog": _vm.slDeleted }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMobile
        ? _c(
            "v-dialog",
            {
              attrs: { "max-width": "900px" },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "primary", dark: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-toolbar-title", { staticClass: "ma-0" }, [
                    _vm._v("View Submission")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("action-icons", {
                    attrs: {
                      fromDashboard: _vm.fromDashboard,
                      submission: _vm.submission
                    },
                    on: { "service-log:deleted": _vm.slDeleted }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c("confirmation-page", {
                        attrs: {
                          submission: _vm.submission,
                          dialog: _vm.dialog
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63070084", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63070084","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/history/submission-history-dialog.vue
// module id = null
// module chunks = 